import React, { useState } from "react";

import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Space,
  Table,
} from "antd";

import FilterContainer from "../../../../components/common/FilterContainer";
import MultiSelect from "../../../../components/common/MultiSelect";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import { payers, paymentsData } from "../../../../data/accounting";

import { FaDollarSign } from "react-icons/fa";

import "./Payments.css";
import { useNavigate } from "react-router-dom";

const PayablesPaymentsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Enter Bill", "1", "", "", "/accounting/payables_bills/bills/enter-bils"),
    RightBarMethod("Automated AP", "2", "", "", ""),
    RightBarMethod("Smart Bill Entry", "3", "", "", "/accounting/payables_bills/bills/smartbillentry"),
    RightBarMethod("Enter Utility Bill (RUBS)", "5", "", "", "/accounting/payables_bills/bills/utility-bill-details"),
    RightBarMethod("Enter Credit", "6", "", "", ""),
    RightBarMethod("Pay Bills", "7", "", "", "/accounting/payables_bills/paybills"),
    RightBarMethod("Tenant Payable", "8", "", "", "/accounting/payables_bills/bills/newtenantpayable"),
    RightBarMethod("New Recurring Bill", "9", "", "", "/accounting/payables_bills/recurring_invoices/newrecurringbill"),
    RightBarMethod("Manually Post Bills", "10", "", "", "/accounting/payables_bills/recurring_invoices/manually_post_bills"),
    RightBarMethod("Upload Bulk Bills", "11", "", "", "/accounting/payables_bills/bills/upload-bulk-bills"),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [RightBarMethod("Aged Payables Summary", "12", "", "", "/")]
  ),
];

function Payments() {
  const [sortedInfo, setSortedInfo] = useState({});

  const navigate = useNavigate();

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => a.date.length - b.date.length,
      sortOrder: sortedInfo.columnKey === "date" ? sortedInfo.order : null,
    },
    {
      title: "Payee",
      dataIndex: "payee",
      key: "payee",
      sorter: (a, b) => a.payee.length - b.payee.length,
      sortOrder: sortedInfo.columnKey === "payee" ? sortedInfo.order : null,
    },
    {
      title: "Bank Account",
      dataIndex: "bankAccount",
      key: "bankAccount",
      sorter: (a, b) => a.bankAccount.length - b.bankAccount.length,
      sortOrder:
        sortedInfo.columnKey === "bankAccount" ? sortedInfo.order : null,
    },
    {
      title: "Reference",
      dataIndex: "reference",
      key: "reference",
      sorter: (a, b) => a.reference.length - b.reference.length,
      sortOrder: sortedInfo.columnKey === "reference" ? sortedInfo.order : null,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
      sortOrder: sortedInfo.columnKey === "amount" ? sortedInfo.order : null,
    },
    {
      title: "Last Printed",
      dataIndex: "lastPrinted",
      key: "lastPrinted",
      sorter: (a, b) => a.lastPrinted.length - b.lastPrinted.length,
      sortOrder:
        sortedInfo.columnKey === "lastPrinted" ? sortedInfo.order : null,
    },
  ];
  return (
    <>
      <div className="payments">
        <PageHeading heading="Payments" />
        <Row>
          <Col span={24}>
            <FilterContainer
              heading={"Filter receipts with the options below."}
            >
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Bank Accounts">
                      <Input placeholder="Search by bank account" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payees">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by Payees"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Reference">
                      <Input placeholder="Search by reference" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Amount">
                      <InputNumber
                        placeholder="Search by amount"
                        addonBefore={<FaDollarSign size={12} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="From" required>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                        <Col>
                          <span>To</span>
                        </Col>
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <Row>
          <Col className="table-container" span={24}>
            <Table
              columns={columns}
              dataSource={[]}
              onChange={handleChange}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/accounting/payables_bills/payments/payment/${record?.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PayablesPaymentsRightBar} />
      </div>
    </>
  );
}

export default Payments;
